import DialogConfirm from './DialogConfirm'
import DialogApply from './DialogApply'
import DialogWarning from './DialogWarning'
import DialogDanger from './DialogDanger'
import DialogNotification from './DialogNotification'
import DialogBase from './DialogBase'

export default DialogApply
export { DialogConfirm, DialogWarning, DialogDanger, DialogNotification, DialogBase }
